// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Cores - Tema Claro */
  --bg-primary: #ffffff;
  --bg-secondary: #f5f5f5;
  --bg-tertiary: #e0e0e0;
  --text-primary: #212121;
  --text-secondary: #757575;
  --text-tertiary: #9e9e9e;
  --border-color: #e0e0e0;
  --shadow: rgba(0, 0, 0, 0.1);
  --shadow-hover: rgba(0, 0, 0, 0.15);
  
  /* Cores de marca (mantém em ambos os temas) */
  --color-primary: #0066cc;
  --color-success: #28a745;
  --color-warning: #ffc107;
  --color-danger: #dc3545;
  --color-info: #17a2b8;
}

/* Tema Escuro */
[data-theme="dark"] {
  --bg-primary: #121212;
  --bg-secondary: #1e1e1e;
  --bg-tertiary: #2d2d2d;
  --text-primary: #e0e0e0;
  --text-secondary: #b0b0b0;
  --text-tertiary: #808080;
  --border-color: #404040;
  --shadow: rgba(0, 0, 0, 0.3);
  --shadow-hover: rgba(0, 0, 0, 0.5);
  
  /* Ajustes nas cores de marca para melhor contraste */
  --color-primary: #4d9fff;
  --color-success: #4caf50;
  --color-warning: #ffb300;
  --color-danger: #f44336;
  --color-info: #29b6f6;
}

/* Detecção automática do modo escuro do sistema */
@media (prefers-color-scheme: dark) {
  :root:not([data-theme="light"]) {
    --bg-primary: #121212;
    --bg-secondary: #1e1e1e;
    --bg-tertiary: #2d2d2d;
    --text-primary: #e0e0e0;
    --text-secondary: #b0b0b0;
    --text-tertiary: #808080;
    --border-color: #404040;
    --shadow: rgba(0, 0, 0, 0.3);
    --shadow-hover: rgba(0, 0, 0, 0.5);
    --color-primary: #4d9fff;
    --color-success: #4caf50;
    --color-warning: #ffb300;
    --color-danger: #f44336;
    --color-info: #29b6f6;
  }
}

/* Estilos globais com variáveis CSS */
body {
  background-color: var(--bg-primary);
  color: var(--text-primary);
}

.card,
.MuiCard-root {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
}

input,
select,
textarea,
.MuiInputBase-root {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  border-color: var(--border-color);
}

input::placeholder {
  color: var(--text-tertiary);
}

/* Transições suaves ao trocar de tema */
*,
*::before,
*::after {
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

/* Desabilitar transição em elementos que não precisam */
button,
a,
.MuiButton-root {
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/themes.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,mCAAmC;;EAEnC,8CAA8C;EAC9C,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,kCAAkC;;EAElC,qDAAqD;EACrD,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,kDAAkD;AAClD;EACE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;IACvB,4BAA4B;IAC5B,kCAAkC;IAClC,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,uBAAuB;IACvB,qBAAqB;EACvB;AACF;;AAEA,sCAAsC;AACtC;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;;EAEE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;;;;EAIE,mCAAmC;EACnC,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;;;EAGE,+EAA+E;AACjF;;AAEA,wDAAwD;AACxD;;;EAGE,kGAAkG;AACpG","sourcesContent":[":root {\r\n  /* Cores - Tema Claro */\r\n  --bg-primary: #ffffff;\r\n  --bg-secondary: #f5f5f5;\r\n  --bg-tertiary: #e0e0e0;\r\n  --text-primary: #212121;\r\n  --text-secondary: #757575;\r\n  --text-tertiary: #9e9e9e;\r\n  --border-color: #e0e0e0;\r\n  --shadow: rgba(0, 0, 0, 0.1);\r\n  --shadow-hover: rgba(0, 0, 0, 0.15);\r\n  \r\n  /* Cores de marca (mantém em ambos os temas) */\r\n  --color-primary: #0066cc;\r\n  --color-success: #28a745;\r\n  --color-warning: #ffc107;\r\n  --color-danger: #dc3545;\r\n  --color-info: #17a2b8;\r\n}\r\n\r\n/* Tema Escuro */\r\n[data-theme=\"dark\"] {\r\n  --bg-primary: #121212;\r\n  --bg-secondary: #1e1e1e;\r\n  --bg-tertiary: #2d2d2d;\r\n  --text-primary: #e0e0e0;\r\n  --text-secondary: #b0b0b0;\r\n  --text-tertiary: #808080;\r\n  --border-color: #404040;\r\n  --shadow: rgba(0, 0, 0, 0.3);\r\n  --shadow-hover: rgba(0, 0, 0, 0.5);\r\n  \r\n  /* Ajustes nas cores de marca para melhor contraste */\r\n  --color-primary: #4d9fff;\r\n  --color-success: #4caf50;\r\n  --color-warning: #ffb300;\r\n  --color-danger: #f44336;\r\n  --color-info: #29b6f6;\r\n}\r\n\r\n/* Detecção automática do modo escuro do sistema */\r\n@media (prefers-color-scheme: dark) {\r\n  :root:not([data-theme=\"light\"]) {\r\n    --bg-primary: #121212;\r\n    --bg-secondary: #1e1e1e;\r\n    --bg-tertiary: #2d2d2d;\r\n    --text-primary: #e0e0e0;\r\n    --text-secondary: #b0b0b0;\r\n    --text-tertiary: #808080;\r\n    --border-color: #404040;\r\n    --shadow: rgba(0, 0, 0, 0.3);\r\n    --shadow-hover: rgba(0, 0, 0, 0.5);\r\n    --color-primary: #4d9fff;\r\n    --color-success: #4caf50;\r\n    --color-warning: #ffb300;\r\n    --color-danger: #f44336;\r\n    --color-info: #29b6f6;\r\n  }\r\n}\r\n\r\n/* Estilos globais com variáveis CSS */\r\nbody {\r\n  background-color: var(--bg-primary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.card,\r\n.MuiCard-root {\r\n  background-color: var(--bg-secondary);\r\n  border-color: var(--border-color);\r\n}\r\n\r\ninput,\r\nselect,\r\ntextarea,\r\n.MuiInputBase-root {\r\n  background-color: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  border-color: var(--border-color);\r\n}\r\n\r\ninput::placeholder {\r\n  color: var(--text-tertiary);\r\n}\r\n\r\n/* Transições suaves ao trocar de tema */\r\n*,\r\n*::before,\r\n*::after {\r\n  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;\r\n}\r\n\r\n/* Desabilitar transição em elementos que não precisam */\r\nbutton,\r\na,\r\n.MuiButton-root {\r\n  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
